import { render, staticRenderFns } from "./JointTableRow.vue?vue&type=template&id=6c52dc21"
import script from "./JointTableRow.vue?vue&type=script&lang=js"
export * from "./JointTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports